import { StateSchema } from 'app/config/storeConfig/types';
import { DiscountFormDrawerSchema } from '../types';

export const getDiscountFormState = (state: StateSchema): DiscountFormDrawerSchema => state.discountFormDrawer;
